module.exports = __webpack_public_path__ + "static/media/popup-bg@2x.d1e5ba53.png";